// extracted by mini-css-extract-plugin
module.exports = {"desktop_only":"(min-width: 1024px)","wrapper":"wrapper-2Bjsj","timelimit":"timelimit-29q3p"};